import axios from '@/utils/request'

export default {
	// 2021-10-10
	findByIdWeddingDressHall(id) {
		return axios.get('/weddingDressHall/user-auth/' + id)
	},
	// 2021-10-26
	createWeddingDressHall(params) {
		return axios.post('/weddingDressHall/user-auth', params)
	},
	// 2021-10-10
	updateWeddingDressHall(id, params) {
		return axios.put('/weddingDressHall/user-auth/' + id, params)
	},
	// 2021-10-13
	findByIdsWeddingDressHall(params) {
		return axios.put('/weddingDressHall/user-auth/find-by-ids', params)
	},
	// 2021-10-13
	checkTenantValid() {
		return axios.get('/weddingDressHall/user-auth/check-tenant-valid')
	},
}

